import { render, staticRenderFns } from "./ConfigPrincipalList.vue?vue&type=template&id=1ca5fa77&scoped=true&"
import script from "./ConfigPrincipalList.vue?vue&type=script&lang=js&"
export * from "./ConfigPrincipalList.vue?vue&type=script&lang=js&"
import style0 from "./ConfigPrincipalList.vue?vue&type=style&index=0&id=1ca5fa77&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca5fa77",
  null
  
)

export default component.exports